import { useQuery, useMutation, useQueryClient } from 'react-query';
import { updateProfile } from '../queries/updateProfile';
import ProfileApi from '../ProfileApi';

export function useGetProfile<T>(enableQuery: boolean) {
    return useQuery<any, any, T>(['get_profile'], () => ProfileApi.load(), {
        enabled: enableQuery
    });
}

export function useUpdateUserProfile<T>() {
    const queryClient = useQueryClient();
    return useMutation<any, any, T>(updateProfile, {
        onSuccess: () => {
            queryClient.invalidateQueries(['get_profile']);
        }
    });
}
